export type IConceptStatus = 'planned' | 'built' | 'dropped';

export type IConcept = {
  code: string;
  title: string;
  level: number;
  klineId: number | null;
  klinePos: number;
  groupCode: string | null;
  panelId: number | null;
  status: IConceptStatus;
  note: string | null;
  conceptText: string | null;
  examples: string | null;
  refLevel: number | null;
  transcription: string | null;
  placedLesson: number | null;
  satisfied: boolean;
  pendingRequires: string[];
  requires: string[];
  requireNotes?: { [requiredCode: string]: string };
};

export type IKLine = {
  id: number;
  name: string;
};

export type IBrowserData = {
  courseId: number;
  examLabel: string;
  targetDialectId: number | null;
  count: number;
  klines: IKLine[];
  concepts: IConcept[];
};

export const LEVEL_NAMES: { [level: number]: string } = {
  1: 'A1.1',
  2: 'A1.2',
  3: 'A2',
  4: 'B1',
};

// Visual state of a node, from strongest to weakest signal.
export type INodeState = 'placed' | 'dropped' | 'gated' | 'blocked' | 'eligible';

export const nodeState = (c: IConcept, maxLevel: number | null): INodeState => {
  if (c.placedLesson !== null) return 'placed';
  if (c.status === 'dropped') return 'dropped';
  if (!c.satisfied) return 'blocked';
  if (maxLevel !== null && c.level > maxLevel) return 'gated';
  return 'eligible';
};
